import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: the intents the UI dispatches for the sagas to act on. Kept
 * out of the slice's reducers: each triggers a side effect (an HTTP call), not a
 * state transition (the sagas own the resulting transitions).
 *
 * None carries a payload: the draft is already in the store, and every endpoint is
 * self-scoped (`/account/email`), where the backend derives the user from the
 * session; so neither the id nor the password travels through an action.
 */

/** Ask for the change (POST); the password challenge happens server-side. */
export const submitRequested = createAction('emailChange/submitRequested');

/** Read the change awaiting confirmation (GET), on mount and after a submit. */
export const pendingLoadRequested = createAction('emailChange/pendingLoadRequested');

/** Abandon the pending change (DELETE); no challenge, see `CancelEmailChange`. */
export const cancelRequested = createAction('emailChange/cancelRequested');
